import { ReadonlyDeep } from "type-fest";
import {
  ClassificationCategory,
  ClassificationType,
  E3_102_001,
  E3_102_002,
  E3_102_003,
  E3_102_004,
  E3_102_005,
  E3_102_006,
  E3_202_001,
  E3_202_002,
  E3_202_003,
  E3_202_004,
  E3_202_005,
  E3_302_001,
  E3_302_002,
  E3_302_003,
  E3_302_004,
  E3_302_005,
  E3_313_001,
  E3_313_002,
  E3_313_003,
  E3_313_004,
  E3_313_005,
  E3_561_001,
  E3_561_002,
  E3_561_003,
  E3_561_004,
  E3_561_005,
  E3_561_006,
  E3_561_007,
  E3_562,
  E3_563,
  E3_564,
  E3_565,
  E3_566,
  E3_567,
  E3_568,
  E3_570,
  E3_581_003,
  E3_585_001,
  E3_585_002,
  E3_585_004,
  E3_585_005,
  E3_585_006,
  E3_585_008,
  E3_585_009,
  E3_585_011,
  E3_585_012,
  E3_585_013,
  E3_585_014,
  E3_585_015,
  E3_585_016,
  E3_586,
  E3_595,
  E3_880_001,
  E3_880_002,
  E3_880_003,
  E3_880_004,
  E3_881_001,
  E3_881_002,
  E3_881_003,
  E3_881_004,
  E3_882_001,
  E3_882_002,
  E3_883_001,
  E3_883_002,
  generalExpensesWithoutVATDiscount,
  generalExpensesWithVATDiscount,
  incomeThirdParty,
  isClassificationCategory,
  isClassificationType,
  otherIncome, otherIncomeInfoEntry,
  purchaseOfAssets,
  purchaseOfMerchandise,
  purchaseOfRawMaterials,
  purchaseOfServices,
  saleOfAsset,
  saleOfMerchandise,
  saleOfProducts,
  saleOfServices,
  selfConsumptionIncome
} from "~/mydata";
import { expectAssignable } from "~/mydata/typeutils";
import {
  accomodationTaxReceipt,
  acquisitionTitleIssueRefusal,
  acquisitionTitleUnobligatedIssuer,
  contractIncome,
  creditInvoiceCorrelated,
  creditInvoiceNonCorrelated,
  InvoiceType, posReceipt,
  rentReceipt,
  retailCreditElement,
  retailSalesReceipt,
  retailServicesReceipt,
  retailSimpleInvoice,
  retailThirdPartySalesReceipt,
  salesInvoice,
  salesInvoiceAdditional,
  salesInvoiceEU,
  salesInvoiceNonEU,
  salesInvoiceSelfPricing,
  salesInvoiceThirdParty,
  selfConsumptionInvoice,
  selfDeliveryInvoice,
  servicesInvoice,
  servicesInvoiceAdditional,
  servicesInvoiceEU,
  servicesInvoiceNonEU,
  settlementInvoice
} from "./invoice";

export const invoiceClassifications = {
  // Validated on 14/11/2022
  [salesInvoice]: {
    [saleOfMerchandise]: [E3_561_001, E3_561_002, E3_561_007],
    [saleOfProducts]: [E3_561_001, E3_561_002, E3_561_007],
    [saleOfServices]: [E3_561_001, E3_561_002, E3_561_007, E3_563],
    [saleOfAsset]: [E3_880_001],
    [otherIncome]: [
      E3_561_002,
      E3_561_007,
      E3_562,
      E3_563,
      E3_564,
      E3_565,
      E3_566,
      E3_567,
      E3_568,
      E3_570,
    ],
    [incomeThirdParty]: [E3_881_001, E3_881_003, E3_881_004],
  },
  [posReceipt]: {
    [saleOfMerchandise]: [E3_561_001, E3_561_002, E3_561_007],
    [saleOfProducts]: [E3_561_001, E3_561_002, E3_561_007],
    [saleOfServices]: [E3_561_001, E3_561_002, E3_561_007, E3_563],
    [saleOfAsset]: [E3_880_001],
    [otherIncome]: [
      E3_561_002,
      E3_561_007,
      E3_562,
      E3_563,
      E3_564,
      E3_565,
      E3_566,
      E3_567,
      E3_568,
      E3_570,
    ],
    [incomeThirdParty]: [E3_881_001, E3_881_003, E3_881_004],
  },
  //Validated on 14/11/2022
  [salesInvoiceSelfPricing]: {
    [purchaseOfMerchandise]: [
      E3_102_001,
      E3_102_003,
      E3_102_006,
      E3_313_001,
      E3_313_005,
    ],
    [purchaseOfRawMaterials]: [E3_202_001, E3_202_005, E3_302_001, E3_302_005],
    [purchaseOfServices]: [
      E3_585_001,
      E3_585_002,
      E3_585_004,
      E3_585_005,
      E3_585_006,
      E3_585_008,
      E3_585_009,
      E3_585_011,
      E3_585_012,
      E3_585_013,
      E3_585_014,
      E3_585_015,
      E3_585_016,
      E3_586,
      E3_581_003,
    ],
    [generalExpensesWithVATDiscount]: [
      E3_585_001,
      E3_585_002,
      E3_585_004,
      E3_585_005,
      E3_585_006,
      E3_585_008,
      E3_585_009,
      E3_585_011,
      E3_585_012,
      E3_585_013,
      E3_585_014,
      E3_585_015,
      E3_585_016,
      E3_586,
      E3_102_001,
      E3_102_003,
      E3_102_004,
      E3_102_005,
      E3_202_003,
      E3_202_004,
      E3_302_003,
      E3_302_004,
      E3_313_003,
      E3_313_004,
      E3_581_003,
    ],
    [generalExpensesWithoutVATDiscount]: [
      E3_585_001,
      E3_585_002,
      E3_585_004,
      E3_585_005,
      E3_585_006,
      E3_585_008,
      E3_585_009,
      E3_585_011,
      E3_585_012,
      E3_585_013,
      E3_585_014,
      E3_585_015,
      E3_585_016,
      E3_586,
      E3_882_001,
      E3_883_001,
      E3_102_001,
      E3_102_003,
      E3_102_004,
      E3_102_005,
      E3_202_003,
      E3_202_004,
      E3_302_003,
      E3_302_004,
      E3_313_003,
      E3_313_004,
      E3_581_003,
    ],
    [purchaseOfAssets]: [E3_882_001, E3_883_001],
  },
  // Validated on 14/11/2022
  [salesInvoiceEU]: {
    [saleOfMerchandise]: [E3_561_005, E3_561_007],
    [saleOfProducts]: [E3_561_005, E3_561_007],
    [saleOfServices]: [E3_561_005, E3_561_007],
    [saleOfAsset]: [E3_880_003],
    [otherIncome]: [E3_561_005, E3_561_007, E3_562, E3_570],
    [incomeThirdParty]: [E3_881_003],
  },
  // Validated on 14/11/2022
  [salesInvoiceNonEU]: {
    [saleOfMerchandise]: [E3_561_006, E3_561_007],
    [saleOfProducts]: [E3_561_006, E3_561_007],
    [saleOfServices]: [E3_561_006, E3_561_007],
    [saleOfAsset]: [E3_880_004],
    [otherIncome]: [E3_561_006, E3_561_007, E3_562, E3_570],
    [incomeThirdParty]: [E3_881_004],
  },
  // Validated on 14/11/2022
  [salesInvoiceThirdParty]: {
    [incomeThirdParty]: [E3_881_001, E3_881_003, E3_881_004],
  },
  // Validated on 14/11/2022
  [settlementInvoice]: {
    [saleOfServices]: [E3_561_001, E3_561_007],
  },
  // Validated on 15/11/2022
  [salesInvoiceAdditional]: {
    [saleOfMerchandise]: [
      E3_561_001,
      E3_561_002,
      E3_561_005,
      E3_561_006,
      E3_561_007,
    ],
    [saleOfProducts]: [
      E3_561_001,
      E3_561_002,
      E3_561_005,
      E3_561_006,
      E3_561_007,
    ],
    [saleOfServices]: [
      E3_561_001,
      E3_561_002,
      E3_561_005,
      E3_561_006,
      E3_561_007,
      E3_563,
    ],
    [saleOfAsset]: [E3_880_001, E3_880_003, E3_880_004],
    [otherIncome]: [
      E3_561_005,
      E3_561_006,
      E3_561_007,
      E3_562,
      E3_563,
      E3_564,
      E3_565,
      E3_566,
      E3_567,
      E3_568,
      E3_570,
      E3_561_002,
    ],
    [incomeThirdParty]: [E3_881_001, E3_881_003, E3_881_004],
  },
  // Validated on 14/11/2022
  [servicesInvoice]: {
    [saleOfServices]: [E3_561_001, E3_561_002, E3_561_007, E3_563],
    [otherIncome]: [
      E3_561_007,
      E3_562,
      E3_563,
      E3_564,
      E3_565,
      E3_566,
      E3_567,
      E3_568,
      E3_570,
    ],
  },
  // Validated on 14/11/2022
  [servicesInvoiceEU]: {
    [saleOfServices]: [E3_561_005, E3_561_007, E3_563],
    [otherIncome]: [E3_561_005, E3_561_007, E3_562, E3_570],
  },
  // Validated on 14/11/2022
  [servicesInvoiceNonEU]: {
    [saleOfServices]: [E3_561_006, E3_561_007, E3_563],
    [otherIncome]: [E3_561_006, E3_561_007, E3_562, E3_570],
  },
  // Validated on 14/11/2022
  [servicesInvoiceAdditional]: {
    [saleOfServices]: [
      E3_561_001,
      E3_561_002,
      E3_561_005,
      E3_561_006,
      E3_561_007,
      E3_563,
    ],
    [otherIncome]: [
      E3_561_005,
      E3_561_006,
      E3_561_007,
      E3_562,
      E3_563,
      E3_564,
      E3_565,
      E3_566,
      E3_567,
      E3_568,
      E3_570,
    ],
  },
  // Validated on 15/11/2022
  [acquisitionTitleUnobligatedIssuer]: {
    [purchaseOfMerchandise]: [
      E3_102_002,
      E3_102_003,
      E3_102_006,
      E3_313_002,
      E3_313_005,
    ],
    [purchaseOfRawMaterials]: [E3_202_002, E3_202_005, E3_302_002, E3_302_005],
    [purchaseOfServices]: [E3_585_004, E3_585_009, E3_585_016],
    [generalExpensesWithoutVATDiscount]: [E3_585_004, E3_585_016, E3_586],
    [purchaseOfAssets]: [E3_882_002, E3_883_002],
  },
  // Validated on 15/11/2022
  [acquisitionTitleIssueRefusal]: {
    [saleOfMerchandise]: [E3_561_001, E3_561_002, E3_561_007],
    [saleOfProducts]: [E3_561_001, E3_561_002, E3_561_007],
    [saleOfServices]: [E3_561_001, E3_561_007, E3_563],
    [saleOfAsset]: [E3_880_001],
    [otherIncome]: [
      E3_561_007,
      E3_562,
      E3_563,
      E3_564,
      E3_565,
      E3_566,
      E3_567,
      E3_568,
      E3_570,
    ],
  },
  // Validated on 15/11/2022
  [creditInvoiceCorrelated]: {
    [saleOfMerchandise]: [
      E3_561_001,
      E3_561_002,
      E3_561_005,
      E3_561_006,
      E3_561_007,
    ],
    [saleOfProducts]: [
      E3_561_001,
      E3_561_002,
      E3_561_005,
      E3_561_006,
      E3_561_007,
    ],
    [saleOfServices]: [
      E3_561_001,
      E3_561_002,
      E3_561_005,
      E3_561_006,
      E3_561_007,
      E3_563,
    ],
    [saleOfAsset]: [E3_880_001, E3_880_003, E3_880_004],
    [otherIncome]: [
      E3_561_002,
      E3_561_005,
      E3_561_006,
      E3_561_007,
      E3_562,
      E3_563,
      E3_564,
      E3_565,
      E3_566,
      E3_567,
      E3_568,
      E3_570,
    ],
    [incomeThirdParty]: [E3_881_001, E3_881_003, E3_881_004],
  },
  // Validated on 14/11/2022
  [creditInvoiceNonCorrelated]: {
    [saleOfMerchandise]: [
      E3_561_001,
      E3_561_002,
      E3_561_005,
      E3_561_006,
      E3_561_007,
    ],
    [saleOfProducts]: [
      E3_561_001,
      E3_561_002,
      E3_561_005,
      E3_561_006,
      E3_561_007,
    ],
    [saleOfServices]: [
      E3_561_001,
      E3_561_002,
      E3_561_005,
      E3_561_006,
      E3_561_007,
      E3_563,
    ],
    [saleOfAsset]: [E3_880_001, E3_880_003, E3_880_004],
    [otherIncome]: [
      E3_561_005,
      E3_561_006,
      E3_561_007,
      E3_562,
      E3_563,
      E3_564,
      E3_565,
      E3_566,
      E3_567,
      E3_568,
      E3_570,
      E3_561_002,
    ],
    [incomeThirdParty]: [E3_881_001, E3_881_003, E3_881_004],
  },
  // Validated on 14/11/2022
  [selfDeliveryInvoice]: {
    [selfConsumptionIncome]: [E3_595],
  },
  // Validated on 14/11/2022
  [selfConsumptionInvoice]: {
    [selfConsumptionIncome]: [E3_595],
  },
  // Validated on 14/11/2022
  [contractIncome]: {
    [saleOfMerchandise]: [E3_561_001, E3_561_002, E3_561_007],
    [saleOfProducts]: [E3_561_001, E3_561_002, E3_561_007],
    [saleOfServices]: [E3_561_001, E3_561_007],
    [saleOfAsset]: [E3_880_001],
    [otherIncome]: [E3_561_007, E3_562, E3_563, E3_570],
  },
  // Validated on 14/11/2022
  [rentReceipt]: {
    [saleOfServices]: [E3_561_001],
    [otherIncome]: [E3_562],
  },
  // Validated on 14/11/2022
  [accomodationTaxReceipt]: {},
  // Validated on 15/11/2022
  [retailSalesReceipt]: {
    [saleOfMerchandise]: [
      E3_561_003,
      E3_561_004,
      E3_561_005,
      E3_561_006,
      E3_561_007,
    ],
    [saleOfProducts]: [
      E3_561_003,
      E3_561_004,
      E3_561_005,
      E3_561_006,
      E3_561_007,
    ],
    [saleOfServices]: [
      E3_561_003,
      E3_561_004,
      E3_561_005,
      E3_561_006,
      E3_561_007,
      E3_563,
    ],
    [saleOfAsset]: [E3_880_002, E3_880_003, E3_880_004, E3_561_007],
    [otherIncome]: [E3_561_007, E3_562, E3_563, E3_570],
    [incomeThirdParty]: [E3_881_002, E3_881_003, E3_881_004],
  },
  // Validated on 15/11/2022
  [retailServicesReceipt]: {
    [saleOfServices]: [E3_561_003, E3_561_005, E3_561_006, E3_561_007, E3_563],
    [otherIncome]: [E3_561_007, E3_562, E3_563, E3_570],
  },
  // Validated on 15/11/2022
  [retailSimpleInvoice]: {
    [saleOfMerchandise]: [
      E3_561_001,
      E3_561_002,
      E3_561_003,
      E3_561_004,
      E3_561_005,
      E3_561_006,
      E3_561_007,
    ],
    [saleOfProducts]: [
      E3_561_001,
      E3_561_002,
      E3_561_003,
      E3_561_004,
      E3_561_005,
      E3_561_006,
      E3_561_007,
    ],
    [saleOfServices]: [
      E3_561_001,
      E3_561_002,
      E3_561_003,
      E3_561_004,
      E3_561_005,
      E3_561_006,
      E3_561_007,
      E3_563,
    ],
    [saleOfAsset]: [E3_880_002, E3_880_003, E3_880_004, E3_561_007],
    [otherIncome]: [E3_561_007, E3_562, E3_563, E3_570],
    [incomeThirdParty]: [E3_881_002, E3_881_003, E3_881_004],
  },
  // Validated on 15/11/2022
  [retailCreditElement]: {
    [saleOfMerchandise]: [
      E3_561_001,
      E3_561_002,
      E3_561_003,
      E3_561_004,
      E3_561_005,
      E3_561_006,
      E3_561_007,
    ],
    [saleOfProducts]: [
      E3_561_001,
      E3_561_002,
      E3_561_003,
      E3_561_004,
      E3_561_005,
      E3_561_006,
      E3_561_007,
    ],
    [saleOfServices]: [
      E3_561_001,
      E3_561_002,
      E3_561_003,
      E3_561_004,
      E3_561_005,
      E3_561_006,
      E3_561_007,
      E3_563,
    ],
    [saleOfAsset]: [E3_880_002, E3_880_003, E3_880_004, E3_561_007],
    [otherIncome]: [E3_561_007, E3_562, E3_563, E3_570],
    [incomeThirdParty]: [E3_881_002, E3_881_003, E3_881_004],
  },
  // Validated on 14/11/2022
  [retailThirdPartySalesReceipt]: {
    [incomeThirdParty]: [E3_881_002, E3_881_003, E3_881_004],
  },
} as const;

type InvoiceClassifications = Partial<
  Record<ClassificationCategory, ClassificationType[]>
>;
expectAssignable<ReadonlyDeep<Record<InvoiceType, InvoiceClassifications>>>(
  invoiceClassifications
);

export const invoiceClassificationCategories = (invoiceType: InvoiceType) =>
  Object.keys(invoiceClassifications[invoiceType]).filter(
    isClassificationCategory
  );
export const invoiceClassificationTypes = (
  invoiceType: InvoiceType,
  category: ClassificationCategory // @ts-expect-error
) => invoiceClassifications[invoiceType][category] ?? [];

export const isValidClassification = (
  invoiceType: InvoiceType,
  cat: ClassificationCategory,
  typ: ClassificationType
) => invoiceClassificationTypes(invoiceType, cat).includes(typ);
